module.exports = __webpack_public_path__ + "static/img/winter_putaoPic.9f1adde6.png";